
const requirementsTempl = require('sma.common/partials/passwordStrength.mustache');

const Strings = {
	helptext: gettext('Your password must contain at least'),
	chars: gettext('8 characters'),
	lowercase: gettext('One lowercase letter'),
	uppercase: gettext('One uppercase letter'),
	number: gettext('One number'),
	specchar: gettext('One special character'),
	show: gettext('Show password'),
	hide: gettext('Hide password'),
};

class PasswordEye extends Backbone.View {
	get events() {
		return {
			'click .sma-js-pwd-view': 'showPassword',
		};
	}

	initialize(element) {
		$(element).wrap('<div class="sma-input-icon-right"></div>');
		$(element).after('<i class="nc-icon-mini ui-1_eye-19 sma-pwd-view sma-js-pwd-view" aria-hidden="true"></i>');

		this.setElement(element.parent());

		this.STATES = {
			visible: 0,
			hidden: 1,
		};

		this.state = this.STATES.hidden;
	}

	showPassword(e) {
		e.preventDefault();

		$(e.currentTarget).toggleClass('ui-1_eye-19, ui-1_eye-ban-20');

		let input = this.$el.find('input');

		if (input.prop('type') == 'password') {
			input.prop('type', 'text');
		} else {
			input.prop('type', 'password');
		}

		input.focus();
	}
}

let Strength = Backbone.View.extend({
	strongRe: new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[\-!@#\$%\^&\*\)\(+=._,;:'\"\<\>/|}{\[\\\]\~\`\? \\\\])(?=.{8,})"),

	lowercaseRe: new RegExp("(?=.*[a-z])"),
	uppercaseRe: new RegExp("(?=.*[A-Z])"),
	numberRe: new RegExp("(?=.*[0-9])"),
	speccharRe: new RegExp("(?=.*[\-!@#\$%\^&\*\)\(+=._,;:'\"\<\>/|}{\[\\\]\~\`\? \\\\])"),

	events: {
		'input': 'onKeyup',
		'blur': 'onBlur',
		'focus': 'onKeyup',
	},

	initialize(config) {
		this.setElement(config.element[0]);
		this.element = config.element;
		this.confirm = config.confirm;

		if (this.confirm) {
			this.confirm.prop('disabled', true);

			this.confirm.keyup(_.debounce(() => {
				this.checkConfirm();
			}, 100));
		}

		new PasswordEye(this.element);
		new PasswordEye(this.confirm);

		let popoverTemplate = '<div class="popover hidden-sm-down" role="tooltip">\
			<div class="popover-arrow"></div>\
			<div class="popover-content"></div></div>';

		this.element.popover({
			html: true,
			content: requirementsTempl({ strings: Strings }),
			container: 'body',
			trigger: 'focus',
			template: popoverTemplate,
		});

		let reqString = `${Strings.helptext}: ${Strings.chars}, ${Strings.uppercase}, ${Strings.lowercase}, ${Strings.number}, ${Strings.specchar}`;
		this.element.parent().after(`<div class="hidden-sm-up">${reqString}</div>`);
	},

	getStrengthElement() {
		return $('.sma-js-pwd-strength-reqs');
	},

	onBlur() {
		this.checkConfirm();
	},

	requirementMet(cls) {
		this.getStrengthElement().find(cls).find('i')
			.removeClass('ui-1_bold-delete')
			.addClass('ui-1_check-simple');
	},

	requirementNotMet(cls) {
		this.getStrengthElement().find(cls).find('i')
			.addClass('ui-1_bold-delete')
			.removeClass('ui-1_check-simple');
	},

	checkConfirm() {
		if (!this.confirm) {
			return;
		}

		this.confirm.removeClass('bad');
		this.confirm.removeClass('good');

		if (this.element.val()) {
			if (this.element.val() != this.confirm.val()) {
				this.confirm.addClass('bad');
			} else {
				this.confirm.addClass('good');
			}
		}
	},

	onKeyup: _.debounce(function(e) {
		let value = $(e.currentTarget).val();
		value = value.trim();

		this.element.removeClass('bad');
		this.element.removeClass('okay');
		this.element.removeClass('good');

		if (!value || value.length < 8) {
			this.element.addClass('bad');
			this.requirementNotMet('.sma-js-pwd-chars');
		} else {
			this.requirementMet('.sma-js-pwd-chars');
		}

		if (this.lowercaseRe.test(value)) {
			this.requirementMet('.sma-js-pwd-lowercase');
		} else {
			this.requirementNotMet('.sma-js-pwd-lowercase');
		}

		if (this.uppercaseRe.test(value)) {
			this.requirementMet('.sma-js-pwd-uppercase');
		} else {
			this.requirementNotMet('.sma-js-pwd-uppercase');
		}

		if (this.numberRe.test(value)) {
			this.requirementMet('.sma-js-pwd-number');
		} else {
			this.requirementNotMet('.sma-js-pwd-number');
		}

		if (this.speccharRe.test(value)) {
			this.requirementMet('.sma-js-pwd-specchar');
		} else {
			this.requirementNotMet('.sma-js-pwd-specchar');
		}

		if (this.strongRe.test(value)) {
			this.confirm.prop('disabled', false);

			if (value.length > 8) {
				this.element.addClass('good');
			}
			else {
				this.element.addClass('okay');
			}

			return;
		}

		this.confirm.prop('disabled', true);
		this.element.addClass('bad');

	}, 100),
});

module.exports = {
	Strength,
	PasswordEye: PasswordEye,
};
